// extracted by mini-css-extract-plugin
export default {"link":"LiveUrls_link__y1WKO"};